import React, { useEffect, useMemo } from "react";
import { useCensusContext } from "domain/Census";
import { ProgressBar } from "shared";

import "./census-indicator.scss";

import moment from "moment";
import "moment/locale/sr";

export const CensusIndicator = () => {
  const { activeCensus, getCensusProgress, progress } = useCensusContext();

  useEffect(() => {
    if (!activeCensus) return;
    getCensusProgress(activeCensus.id);
  }, [activeCensus, getCensusProgress]);

  const timeDifference = useMemo(() => {
    if (!activeCensus) return "Trenutno ne postoji aktivan popis";
    if (!activeCensus?.endDate) return "Aktivan popis nema krajnji datum";
    const endDate = moment(activeCensus.endDate).locale("sr");
    return moment().isBefore(endDate)
      ? `Popis traje još ${moment().to(endDate, true)}`
      : `Rok za popis je probijen za ${endDate.fromNow(true)}`;
  }, [activeCensus]);

  return (
    <div className="census-indicator">
      {progress && <ProgressBar progress={(progress.mainProgress.completed / progress.mainProgress.total) * 100} />}

      <span>{timeDifference}</span>
    </div>
  );
};
